var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiarka1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.142 6.717a8.68 8.68 0 0 0-12.274 0L7.185 67.4a8.678 8.678 0 0 0 0 12.275l14.503 14.503a8.68 8.68 0 0 0 12.275 0l60.683-60.682a8.68 8.68 0 0 0 0-12.275L80.142 6.717zM16.63 66.795l-5.025 5.024a2.433 2.433 0 0 0 0 3.436l14.504 14.504a2.43 2.43 0 0 0 3.436 0l60.682-60.683a2.426 2.426 0 0 0 0-3.436L75.723 11.137a2.43 2.43 0 0 0-3.436 0l-6.117 6.117 2.78 2.778a3.11 3.11 0 0 1 .91 2.197 3.11 3.11 0 0 1-.91 2.196h-.002a3.105 3.105 0 0 1-4.392 0l-2.779-2.778-3.13 3.13 2.777 2.78a3.106 3.106 0 1 1-4.393 4.393l-2.779-2.778-3.13 3.13 6.162 6.164a3.106 3.106 0 0 1-4.393 4.394l-6.163-6.164-3.132 3.132 2.78 2.778a3.11 3.11 0 0 1 0 4.393h-.002a3.105 3.105 0 0 1-4.392 0l-2.779-2.778-3.13 3.13 2.777 2.78a3.106 3.106 0 1 1-4.393 4.393l-2.779-2.778-3.13 3.13 2.778 2.78a3.105 3.105 0 0 1 0 4.392 3.106 3.106 0 0 1-4.394 0l-2.778-2.778-3.132 3.132 6.164 6.163a3.106 3.106 0 0 1-4.394 4.393l-6.163-6.163z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiarka1);
export default __webpack_public_path__ + "static/media/miarka 1.a51e6ae906ca0ba0537c5289b1ac6195.svg";
export { ForwardRef as ReactComponent };